import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-enviar-token',
  imports: [],
  templateUrl: './icon-enviar-token.component.html',
})
export class IconEnviarToken {
  @Input() color: string = '#171717';
  @Input() size: string = '24px';
}
